"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseProcessFlowNodes = void 0;
const index_1 = require("./FlowNodeParsers/index");
function parseProcessFlowNodes(processData, errors, eventDefinitions) {
    const nodes = [];
    const events = index_1.FlowNodeParsers.EventParser.parseEventsFromProcessData(processData, errors, eventDefinitions);
    const gateways = index_1.FlowNodeParsers.GatewayParser.parseGatewaysFromProcessData(processData);
    const activities = index_1.FlowNodeParsers.ActivityParser.parseActivitiesFromProcessData(processData, errors, eventDefinitions);
    nodes.push(...gateways, ...activities, ...events);
    return nodes;
}
exports.parseProcessFlowNodes = parseProcessFlowNodes;
//# sourceMappingURL=FlowNodeParser.js.map